import React from 'react';
import { Droppable as DroppableDND } from 'react-beautiful-dnd';
import { DroppableZone } from './DragAndDropList.styled';
import { getClassForDragOver } from './Droppable.utils';

// type props = {
//   /**
//    * Function to check if item can be dragged over list.
//    *
//    * ```
//    * canItemDragOver(itemId)
//    * ```
//    * @param { String } itemId: The id of the item being dragged over.
//    * @returns { Boolean } If item can be dragged over.
//    */
//   canItemDragOver: (itemId) => boolean,
//   /** List items. Must be ```<DragAndDropList.Draggable>``` */
//   children: node,
//   /** Additional classes. */
//   className: string,
//   /** If dropping is disabled. */
//   disabled: boolean,
//   /** Add class when item is dragged over. */
//   draggingOverClass: string,
//   /** Add class when item cannot be dragged over. */
//   draggingOverErrorClass: string,
//   /** Unique id for this list. */
//   id: string,
// };

export default class Droppable extends React.Component {
  static defaultProps = {
    canItemDragOver: () => true,
    draggingOverClass: '',
    draggingOverErrorClass: '',
    id: 'droppable',
  };

  /**
   * handleItemDragOver
   * Callback function get additional classes when item is dragged over.
   * @param { Object } snapshot: Object containing dnd state.
   * @returns { String } Additional classes.
   */
  getClassForDragOver = ({ isDraggingOver, draggingOverWith }) => {
    return getClassForDragOver(this.props, isDraggingOver, draggingOverWith);
  };

  render() {
    const { children, className, disabled, id } = this.props;
    return (
      <DroppableDND droppableId={id} isDropDisabled={disabled}>
        {(provided, snapshot) => (
          <DroppableZone
            className={`${className} ${this.getClassForDragOver(snapshot)}`}
            ref={provided.innerRef}
          >
            {children}
            {provided.placeholder}
          </DroppableZone>
        )}
      </DroppableDND>
    );
  }
}
